export const frontendVersion =
  process.env.REACT_APP_FRONTEND_VERSION || "dev-local";
